import React, { Component, Fragment } from 'react';
import Table from './Table';
import Paginate from './Paginate';

export default class TableLayout extends Component {
    render(){
        const { data, loading} = this.props
        const { error } = this.props;
        if (error) {
            return (
                <div className="rounded-0 alert alert-warning m-0">
                    Não foi possível carregar a lista de vendas.
                </div>
            );
        }
        if (loading){
            return (
                <div className="rounded-0 alert alert-light m-0">
                    Carregando...
                </div>
            );
        } else {
            const {count} = this.props;
            const {initialPage} = this.props;
            const {onPageClick} = this.props;
            return (
                <Fragment>
                    <div className='card shadow'>
                        <div className='card-header'>
                            <div className='row align-items-center'>
                                <div className='col-8'>
                                    <h5 className='h3 mb-0'>Itens</h5>
                                </div>
                                <h3 className='mb-0'></h3>
                            </div>
                        </div>
                        <Table items={data}/>
                        <Paginate pages={count} initialPage={initialPage} onPageClick={onPageClick} />
                    </div>
                </Fragment>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Items/TableLayout.js